import { StaticFilter } from '../models/staticFilters';

export type ShowLastDeletedToastAction = {
  type: 'PROJECTS/STATIC_FILTERS/SHOW_TOAST';
  filter: StaticFilter;
};

export type ClearLastDeletedToastAction = {
  type: 'PROJECTS/STATIC_FILTERS/CLEAR_TOAST';
};

export const actions = {
  showLastDeletedModal: ({
    filter,
  }: {
    filter: StaticFilter;
  }): ShowLastDeletedToastAction => ({
    type: 'PROJECTS/STATIC_FILTERS/SHOW_TOAST',
    filter,
  }),
  clearLastDeletedModal: (): ClearLastDeletedToastAction => ({
    type: 'PROJECTS/STATIC_FILTERS/CLEAR_TOAST',
  }),
};
